import { BaseApi } from '@smorder/logic';

class ReportsApi extends BaseApi {
  loadLocations() {
    let url = '/api/v2/report/reportscached';

    if (window.location.search.includes('resetcache')) {
      url += '?resetCache=true';
    }


    return this.authorizedFetch(url);
  }

  loadReportData(dto, signal) {
    const data = {
      widgetId: dto.widgetId,
      start: dto.startDate,
      end: dto.endDate,
      ...dto.options,
    };

    const queryString = this.toQueryString(data);
    return this.authorizedFetch(`/api/v1/Report?${queryString}`, { }, signal);
  }

  loadTpsStatus(locationId) {
    return this.authorizedFetch(`/api/v1/tps/aliveFlag/${locationId}`);
  }
}

export default ReportsApi;
